import { render } from "./HistoryEvents.vue?vue&type=template&id=6de09c98"
import script from "./HistoryEvents.vue?vue&type=script&lang=js"
export * from "./HistoryEvents.vue?vue&type=script&lang=js"
script.render = render

export default script